import React from 'react';
import Dashboard from './pages/Dashboard/Dashboard';
import NitaSurveyTab from './components/NitaSurveyTab/NitaSurveyTab';

// Lightweight path routing (no router dependency). nginx SPA fallback serves
// index.html for any path, so /nita loads the app and we branch on the path here.
function isNitaPath() {
  try {
    return window.location.pathname.replace(/\/+$/, '').toLowerCase().endsWith('/nita');
  } catch (_e) {
    return false;
  }
}

function App() {
  if (isNitaPath()) {
    return (
      <div className="app">
        <header className="app-header">
          <h1>NITA National ICT Week — Feedback</h1>
        </header>
        <main>
          <NitaSurveyTab />
          <p style={{ textAlign: 'center', color: '#718096', fontSize: '0.8rem', margin: '1.5rem 0' }}>
            Powered by Ikieguy
          </p>
        </main>
      </div>
    );
  }

  return (
    <div className="app">
      <header className="app-header">
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
          <img src="/starlife-logo.png" alt="StarLife" style={{ height: '36px' }} />
          <h1>Dashboard</h1>
        </div>
      </header>
      <main>
        <Dashboard />
      </main>
    </div>
  );
}

export default App;
